import { APP_NAME } from '@/shared/config'

type UseLocalStorage<Value> = {
    setLSValue: (value: Value) => void
    value: Value
}

export function useLocalStorage<Value>(key: string, initialValue: Value): UseLocalStorage<Value> {
    const keyLS = `${APP_NAME}:${key}`

    const valueLS = window.localStorage.getItem(keyLS)

    const value: Value =
        valueLS && valueLS !== 'undefined' && valueLS !== 'null'
            ? JSON.parse(valueLS)
            : initialValue

    if (value) {
        setLSValue(value)
    }

    function setLSValue(value: Value): void {
        window.localStorage.setItem(keyLS, JSON.stringify(value))
    }

    return { setLSValue, value }
}
